import {createStore,combineReducers, applyMiddleware} from 'redux';
import {thunk} from 'redux-thunk';
import { AuthReducer } from './reducers/authReducer';
import { UserReducer } from './reducers/userReducer';
import { GroupsReducer } from './reducers/groupsReducer';
import { FriendsReducer } from './reducers/friendsReducer';
// import { composeWithDevTools } from '@redux-devtools/extension';
const reducer = combineReducers({
    Auth:AuthReducer,
    User:UserReducer,
    Groups:GroupsReducer,
    Friends:FriendsReducer
});

const initialState = {};
const middleware = [thunk];

const store = createStore(
    reducer,
    initialState,
    // composeWithDevTools(applyMiddleware(...middleware))
    (applyMiddleware(...middleware))

);

export default store;